import React, { useState, useEffect } from "react";
import ViewImageModal from "./ViewImageModal";
import BlogContainer from "./BlogContainer";
import SkeletonContainer from "./SkeletonContainer";

const CustomGalleryModal = ({
  images,
  paddingX,
  paddingY,
  bgColor,
  Skeletontimer = 3000,
  scroll,
  scrollHeight = "80vh",
  objectFit=false
}) => {
  const [viewModal, setViewModal] = useState(false);
  const [imageUrl, setImageUrl] = useState(false);
  const [loading, setLoading] = useState(true); // To manage loading state

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false); // After 2 seconds, render the images
    }, Skeletontimer);

    // Cleanup timeout when component is unmounted or re-rendered
    return () => clearTimeout(timer);
  }, []);
  return (
    <div
      className="grid sm:my-0 lg:my-0 xl:grid-cols-4 sm:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-8 sm:gap-8 sm:mx-0 mx-auto"
      style={{
        background: bgColor ?? "white",
        padding: paddingX && paddingY ? `${paddingY} ${paddingX}` : "4% 6%",
        maxHeight: scroll && scrollHeight,
        overflowX:"hidden",
        overflowY: scroll && "scroll",
      }}
    >
      {loading
        ? images?.map((item, index) => <SkeletonContainer />)
        : images?.map((item, index) => (
            <img
              onClick={() => {
                setViewModal(true);
                setImageUrl(item);
              }}
              key={index}
              src={item}
              loading="lazy"
              alt={`image-${index}`}
              //this is done to handle outof the box images need to change images later 
              className={`cursor-pointer min-w-full max-w- sm:max-w-[380px] h-[260px] ${objectFit ? "object-fit":"sm:object-cover"} lg:w-[100%] rounded-md`}
            />
          ))}

      {viewModal && (
        <ViewImageModal
          images={images ?? []}
          setOpenModal={setViewModal}
          url={imageUrl}
        />
      )}
    </div>
  );
};

export default CustomGalleryModal;
